module.exports = __webpack_public_path__ + "img/qc20.1bd07ef6.png";